import React from 'react';
import { connect } from 'react-redux';

import { fetchEmployer, updateEmployer, getLogo64 } from '../../store/actions/employer';
import { fetchStates, fetchCities, fetchAddress } from '../../store/actions/staticLocations';
import UpdateEmployer from '../../components/UpdateEmployer/UpdateEmployer';

class Employer extends React.Component {
  componentDidMount() {
    this.props.onFetchEmployer(this.props.companyCode);
    //this.props.onFetchStates('BRASIL');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data.stateCod && nextProps.data.stateCod !== this.props.data.stateCod) {
      this.props.onFetchCities(nextProps.data.stateCod);
    }

    if (nextProps.searchAddress !== this.props.searchAddress && nextProps.searchAddress !== {}) {

    }
  }

  handlerCities(stateCode) {
    this.props.onFetchCities(stateCode);
  }

  handlerAddress(cep) {
    this.props.onFetchAddress(cep);
  }

  render() {
    const {
      data, onUpdateEmployer, onGetLogo64, loading, logo, states, cities, searchAddress,
    } = this.props;

    return (
      <UpdateEmployer
        data={data}
        UpdateEmployer={onUpdateEmployer}
        getLogo64={onGetLogo64}
        loading={loading}
        logo={logo}
        states={states}
        cities={cities}
        searchAddress={searchAddress}
        fetchCities={stateCode => this.handlerCities(stateCode)}
        fetchAddress={cep => this.handlerAddress(cep)}
      />
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  message: state.general.message,
  companyCode: state.auth.companyCode,
  data: state.data.data,
  logo: state.data.logo,
  states: state.staticLocations.states,
  cities: state.staticLocations.cities,
  searchAddress: state.staticLocations.searchAddress,
});

const mapDispatchToProps = dispatch => ({
  onUpdateEmployer: data => dispatch(updateEmployer(data)),
  onFetchEmployer: companyCode => dispatch(fetchEmployer(companyCode)),
  onGetLogo64: logo => dispatch(getLogo64(logo)),
  //onFetchStates: countryCode => dispatch(fetchStates(countryCode)),
  onFetchCities: stateCode => dispatch(fetchCities(stateCode)),
  onFetchAddress: cep => dispatch(fetchAddress(cep)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Employer);
